export class PartnerRequestReport {
    dateFrom:string=''
    dateTo:string=''
    
}
